import React from 'react'

import { styled } from '~/styled'
import { cn } from '~/styled'

import { Image } from '../image/Image'
import { Text } from '../text/Text'

export const TopBarBrandLogo = ({
  src,
  alt = 'Atom Learning logo',
  className
}: Pick<React.ComponentProps<typeof Image>, 'src' | 'alt'> & {
  className?: string
}): React.JSX.Element => {
  return (
    <Image
      src={src}
      alt={alt}
      className={cn('h-8', 'mr-3', 'w-auto', className)}
    />
  )
}

export const TopBarBrandName = styled(Text, {
  base: ['text-grey-800']
})

export const TopBarBrand = styled('a', {
  base: [
    'flex',
    'items-center',
    'no-underline',
    'text-grey-800',
    'hover:no-underline',
    'focus:no-underline'
  ]
})
